export enum BaseApiRoutes {
  ZIPPOPOTAM = "//api.zippopotam.us/",
  MAILCHIMP = "",
}
